import { deleteKnowledgeUnit } from "@shared/services/knowledgeSpaces";

export const knowledgeSpacesI18n = {
  de: {
    knowledgeUnit: "Wissensbaustein | Wissensbausteine",
    knowledgeEntries: "Wissenseinträge",
    createKnowledgeUnit: "Wissensbaustein erstellen",
    thisKnowledgeUnitIsntPartOfAKnowledgeSpace:
      "Dieser Wissensbaustein ist aktuell kein Teil eines Wissensraumes",
    noDocumentsFound: "Keine Dokumente gefunden",
    knowledgeModel: "Wissensmodell",
    chunks: "Chunks",
    keyword: "Keyword",
    keywords: "Keywords",
    normalizedKeyword: "Normalisiert",
    deleteKeywordConfirm:
      'Möchten Sie das Keyword "{keyword}" wirklich löschen?',
    editChunk: "Chunk bearbeiten",
    addChunk: "Chunk hinzufügen",
    editKeyword: "Keyword bearbeiten",
    addKeyword: "Keyword hinzufügen",
    deleteKnowledgeSpace: "Wissensraum löschen",
    deleteKnowledgeSpaceConfirm:
      "Sind sie sicher dass sie den Wissensraum {name} löschen möchten? Bitte geben Sie den Namen des Wissensraumes zur Bestätigung ein.",
    enterKnowledgeSpaceNameToDelete: "Name des Wissensraumes",
    knowledgeSpaceDeleted: "Wissensraum erfolgreich gelöscht",
    errorDeletingChat: "Fehler beim Löschen des Chats: {error}",
    deleteKnowledgeUnit: "Wissensbaustein löschen",
    deleteKnowledgeUnitMessage:
      "Sind Sie sicher, dass Sie den Wissensbaustein {name} löschen möchten? Es werden alle versionen, welche nicht von Chats referenziert werden, gelöscht.",
    errorDeletingKnowledgeUnit:
      "Fehler beim Löschen des Wissensbausteins: {error}",
    activateUnitsOnCreate: "Wissensbausteine bei Erstellung aktivieren",
    editKnowledgeUnit: "Wissensbaustein bearbeiten",
    duplicate: "Duplizieren",
    removeFromSpace: "Aus Wissensraum entfernen",
    selectedCount: "{count} ausgewählt",
    activateSelected: "Ausgewählte aktivieren",
    deactivateSelected: "Ausgewählte deaktivieren",
    removeSelected: "Ausgewählte entfernen",
    confirmBulkRemove:
      "Möchten Sie {count} Wissensbausteine aus dem Wissensraum entfernen?",
  },
  en: {
    knowledgeUnit: "Knowledge unit | Knowledge units",
    knowledgeEntries: "Knowledge entries",
    createKnowledgeUnit: "Create knowledge unit",
    thisKnowledgeUnitIsntPartOfAKnowledgeSpace:
      "This knowledge unit is not part of any knowledge space",
    noDocumentsFound: "No documents found",
    knowledgeModel: "Knowledge model",
    chunks: "Chunks",
    keyword: "Keyword",
    keywords: "Keywords",
    normalizedKeyword: "Normalized",
    deleteKeywordConfirm:
      'Do you really want to delete the keyword "{keyword}"?',
    editChunk: "Edit chunk",
    addChunk: "Add chunk",
    editKeyword: "Edit keyword",
    addKeyword: "Add keyword",
    deleteKnowledgeSpace: "Delete knowledge space",
    deleteKnowledgeSpaceConfirm:
      "Are you sure you want to delete the knowledge space {name}? Please enter the name of the knowledge space to confirm.",
    enterKnowledgeSpaceNameToDelete: "Name of the knowledge space",
    knowledgeSpaceDeleted: "Knowledge space successfully deleted",
    errorDeletingChat: "Error deleting chat: {error}",
    deleteKnowledgeUnit: "Delete knowledge unit",
    deleteKnowledgeUnitMessage:
      "Are you sure you want to delete the knowledge unit {name}? All versions that are not referenced by chats will be deleted.",
    errorDeletingKnowledgeUnit: "Error deleting knowledge unit: {error}",
    activateUnitsOnCreate: "Activate knowledge units on creation",
    editKnowledgeUnit: "Edit knowledge unit",
    duplicate: "Duplicate",
    removeFromSpace: "Remove from space",
    selectedCount: "{count} selected",
    activateSelected: "Activate selected",
    deactivateSelected: "Deactivate selected",
    removeSelected: "Remove selected",
    confirmBulkRemove: "Remove {count} knowledge units from the space?",
  },
};
